import { render, staticRenderFns } from "./TableRowNumErrorsPerTech.vue?vue&type=template&id=5d101330&lang=pug&"
import script from "./TableRowNumErrorsPerTech.vue?vue&type=script&lang=js&"
export * from "./TableRowNumErrorsPerTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d101330')) {
      api.createRecord('5d101330', component.options)
    } else {
      api.reload('5d101330', component.options)
    }
    module.hot.accept("./TableRowNumErrorsPerTech.vue?vue&type=template&id=5d101330&lang=pug&", function () {
      api.rerender('5d101330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/table-rows/TableRowNumErrorsPerTech.vue"
export default component.exports